module.exports = __webpack_public_path__ + "img/product-mmm.16dd26d9.jpg";